import _ from 'lodash';

import { PANEL_CONFIGURATIONS } from '../../../constants/PanelLayoutConstants';
import { ARROW_DIRECTION } from '../CustomGridPanel/ArrowButton';

export const getLeftPanelProps = ({ config, setConfig, otherProps }) => {
  let panelProps = {};

  if (
    config === PANEL_CONFIGURATIONS.LEFT_COLLAPSED ||
    config === PANEL_CONFIGURATIONS.ONLY_MIDDLE ||
    config === PANEL_CONFIGURATIONS.ONLY_RIGHT
  ) {
    panelProps = {
      widthPercent: 0,
    };
  } else if (config === PANEL_CONFIGURATIONS.RIGHT_COLLAPSED) {
    panelProps = {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_MIDDLE),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.RIGHT_COLLAPSED}.widthPercent`,
        20
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED) {
    panelProps = {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_RIGHT),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED}.widthPercent`,
        20
      ),
    };
  } else {
    panelProps = {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED),
      widthPercent: 20,
    };
  }

  return panelProps;
};

export const getMiddlePanelProps = ({ config, setConfig, otherProps }) => {
  let panelProps = {};

  if (
    config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED ||
    config === PANEL_CONFIGURATIONS.ONLY_RIGHT
  ) {
    panelProps = {
      widthPercent: 0,
    };
  } else if (config === PANEL_CONFIGURATIONS.LEFT_COLLAPSED) {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_RIGHT),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.LEFT_COLLAPSED}.widthPercent`,
        60
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.RIGHT_COLLAPSED) {
    panelProps = {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.RIGHT_COLLAPSED}.widthPercent`,
        80
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.ONLY_MIDDLE) {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.RIGHT_COLLAPSED),
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED),
      widthPercent: 100,
    };
  } else {
    panelProps = {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED),
      widthPercent: 40,
    };
  }

  return panelProps;
};

export const getMiddleAsRightPanelProps = ({ config, setConfig, otherProps }) => {
  if (
    config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED ||
    config === PANEL_CONFIGURATIONS.ONLY_RIGHT
  ) {
    return {
      widthPercent: 0,
    };
  } else if (config === PANEL_CONFIGURATIONS.LEFT_COLLAPSED) {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_RIGHT),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.LEFT_COLLAPSED}.widthPercent`,
        60
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.RIGHT_COLLAPSED) {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.RIGHT_COLLAPSED}.widthPercent`,
        80
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.ONLY_MIDDLE) {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED),
      widthPercent: 100,
    };
  } else {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED),
      widthPercent: 40,
    };
  }
};

export const getRightPanelProps = ({ config, setConfig, otherProps, isMiddlePanelEnabled }) => {
  let panelProps = {};

  if (
    config === PANEL_CONFIGURATIONS.RIGHT_COLLAPSED ||
    config === PANEL_CONFIGURATIONS.ONLY_MIDDLE
  ) {
    panelProps = {
      widthPercent: 0,
    };
  } else if (config === PANEL_CONFIGURATIONS.LEFT_COLLAPSED) {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_MIDDLE),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.LEFT_COLLAPSED}.widthPercent`,
        40
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED) {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED}.widthPercent`,
        80
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.ONLY_RIGHT) {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () =>
        setConfig(
          isMiddlePanelEnabled
            ? PANEL_CONFIGURATIONS.LEFT_COLLAPSED
            : PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED
        ),
      widthPercent: 100,
    };
  } else {
    panelProps = {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.RIGHT_COLLAPSED),
      widthPercent: 40,
    };
  }

  return panelProps;
};

export const getRightAsMiddlePanelProps = ({ config, setConfig, otherProps }) => {
  if (
    config === PANEL_CONFIGURATIONS.RIGHT_COLLAPSED ||
    config === PANEL_CONFIGURATIONS.ONLY_MIDDLE
  ) {
    return {
      widthPercent: 0,
    };
  } else if (config === PANEL_CONFIGURATIONS.LEFT_COLLAPSED) {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ONLY_MIDDLE),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.LEFT_COLLAPSED}.widthPercent`,
        60
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED) {
    return {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.ALL_EXPANDED),
      widthPercent: _.get(
        otherProps,
        `panelProps.${PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED}.widthPercent`,
        80
      ),
    };
  } else if (config === PANEL_CONFIGURATIONS.ONLY_RIGHT) {
    return {
      leftBtnDirection: ARROW_DIRECTION.RIGHT,
      onLeftBtnClick: () => setConfig(PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED),
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED),
      widthPercent: 100,
    };
  } else {
    return {
      rightBtnDirection: ARROW_DIRECTION.LEFT,
      onRightBtnClick: () => setConfig(PANEL_CONFIGURATIONS.RIGHT_COLLAPSED),
      widthPercent: 40,
    };
  }
};
